import {
  Input,
  Select,
  UnitInput
} from '@oliasoft-open-source/react-ui-library';
import { DATE_FIELDS } from 'common/enums/entity-enums';
import {
  getEntityParameterEnumOptions, getEntityParameterEnums
} from '../query-utils';
import { ICondition } from 'common/interfaces/query';
import { unum } from '@oliasoft-open-source/units';
import { entityTypeMap, getPreferredUnit } from 'common/table-viewer/utils';
import { UnitContext } from 'client/views/hoc/with-unit-template';
import { useContext } from 'react';

interface IQueryConditionCell {
  item: ICondition;
  updateCondition: (index: number, changes: Partial<ICondition>) => void;
  index: number
  width?: number | string;
}

export const QueryConditionCell = (
  {
    item, updateCondition, index, width
  }: IQueryConditionCell,
) => {
  const unitTemplate = useContext(UnitContext);


  const getInputNode = () => {
    const isSelect = getEntityParameterEnums(item.entityType, item.entityPropertyName);
    const isDate = DATE_FIELDS.some(field => item.entityPropertyName.includes(field));
    const { unit, quantity } = entityTypeMap.get(item.entityType)?.get(item.entityPropertyName) ?? {};

    let selectOptions: { label: string, value: string }[] = [];
    if (isSelect) {
      selectOptions = getEntityParameterEnumOptions(item.entityType, item.entityPropertyName);
    }

    if (isSelect) {
      return <Select
        value={item.conditionValue}
        options={selectOptions}
        name="conditionValue"
        onChange={(event) => updateCondition(index, { [event.target.name]: event.target.value })}
        width={width}
      />
    }
    if (isDate) {
      return <Input
        type={"date"}
        value={item.conditionValue}
        name="conditionValue"
        onChange={(event) => updateCondition(index, { [event.target.name]: event.target.value })}
        width={width}
      />
    }
    if (unit && quantity) {
      const unitTemplateUnit = getPreferredUnit(quantity, unitTemplate)
      const convertedValue = String(unum(item.conditionValue as string, unitTemplateUnit!, unit)) + '|' + unitTemplateUnit
      return <UnitInput
        unitTemplate={unitTemplate}
        initUnit={unitTemplateUnit}
        unitkey={quantity}
        value={convertedValue}
        name="conditionValue"
        onChange={(event) => updateCondition(index, { [event.target.name]: event.target.value })}
        width={width}
      />
    }
    return <Input
      type={"input"}
      value={item.conditionValue}
      name="conditionValue"
      onChange={(event) => updateCondition(index, { [event.target.name]: event.target.value })}
      width={width}
    />
  }

  return getInputNode();
}